import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import PageTitle from '../components/PageTitle';

const styles = theme => ({
  intro: {
    marginTop: 30,
    marginBottom: 30,
    padding: 30,
    textAlign: 'justify',
  },
  font: {
    fontSize: 19,
    color: theme.palette.grey.main
  }
});

class About extends Component {

  render() {

    const { classes } = this.props;
    return (
      <div>
        <PageTitle title="About" />
        <Grid container
          direction="row"
          alignItems="center"
          justify="center"
        >
          <Grid item xs={12} sm={8}>
            <div className={classes.intro}>

              <Typography className={classes.font} variant="subtitle1">
              Dr. Julie has operated a piano studio for over 24 years. She believes piano can be attainable for
                everyone given proper training. Dr. Julie was raised in New Hampshire where her formal piano
              study began at an early age. She volunteered as a junior choir director and church accompanist
              for four years and sang in 4-H choirs. In addition, she was first chair trombonist in her high
                school band and played at the NHMEA All-State Band Festivals. Dr. Julie enjoyed playing
              trombone in her high school marching band and jazz ensembles. She obtained a bachelor’s
              degree from Skidmore College, a master’s degree from Florida International University, and a
              doctoral degree from Nova Southeastern University. For 7 years, she taught music, directed
                musical performances, and offered private piano classes at Holy Cross Lutheran School. She is
              an active faculty member of the National Piano Guild and currently serves as the chairperson for
                the Miami chapter of the National Guild of Piano Teachers. <br/> <br/>
                By combining her personal background and training in piano performance and music curriculum
              instruction, Dr. Julie teaches piano performance, technique, and theory classes. For over 10
                years, she has served on the faculty at Miami Dade College and Broward College. Dr. Julie has
              researched and published several articles, a book chapter, and a book about education, diverse
              student learning styles, and student needs. She has presented at several international conferences
              and continues to research student learning and music education. Dr. Julie volunteers within her
              local community, playing in small ensembles, leading music workshops and seminars, and
              managing the Miami center of the National Piano Guild. She has prepared students for benefit
                concerts, annual shows and competitions, as well as auditions with the American College of
              Musicians.
              </Typography>
            </div>
            <Divider />
          </Grid>
        </Grid>

      </div>
    )
  }
}

About.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(About);

